import { CheckIcon, CloseIcon } from '@chakra-ui/icons'
import { Box, Img, Spinner, Tag, Text } from '@chakra-ui/react'
import { getColorScheme } from './multiFileUpload.support'

export const CloudLink = ({
  status,
  errorMessage
}: {
  status: string | object | Response | null | undefined
  errorMessage?: string
}): JSX.Element => (
  <Box>
    <>
      {typeof status === 'string' && (
        <Tag colorScheme={getColorScheme(status ?? '')} p="2" fontSize={'10px'}>
          {status === 'loading' && <Spinner boxSize={3} mr="2" />}
          {status === 'Error' && <CloseIcon boxSize={2} mr="2" />}
          {status !== 'loading' && status !== 'Error' && <CheckIcon mr="2" boxSize={3} />}
          <a href={status} rel="noreferrer" target="_blank">
            {(() => {
              try {
                const url = new URL(status)
                const pathname = url.pathname
                const fileName = pathname.split('/').pop() || 'Unknown File'
                return fileName
              } catch {
                return status
              }
            })()}
          </a>
          {status !== 'loading' && status !== 'Error' && <Img src={status} width="40px" />}
          {status === 'Error' && <Text pl="1">{errorMessage}</Text>}
        </Tag>
      )}
    </>
  </Box>
)
